function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { actions as appActions } from '../../../reducers/app.reducer';
import { useDispatch } from 'react-redux';
var P10Blocks = function P10Blocks(_ref) {
  var page = _ref.page;
  var thisPage = 10;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    timeArr = _useState2[0],
    setTimeArr = _useState2[1];
  var clearTimers = function clearTimers() {
    timeArr.forEach(function (x) {
      return clearTimeout(x);
    });
    setTimeArr([]);
  };
  useEffect(function () {
    return function () {
      return clearTimers();
    };
  }, []);
  useEffect(function () {
    clearTimers();
    if (page === thisPage) {
      setTimeArr([setTimeout(function () {
        $('.p10-blocks').addClass('p10-blocks__active');
      }, 3500)]);
    } else {
      $('.p10-blocks').removeClass('p10-blocks__active');
    }
  }, [page]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "p10-blocks"
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p10/yellow-line@3x.png",
    className: "p10-blocks__line1"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p10/providing-waste-disposal-services-including@3x.png",
    className: "p10-blocks__title"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p10/yellow-line@3x.png",
    className: "p10-blocks__line2"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p10/our-high-quality-recycled-sands-and-aggregates-meet-nysdec-reme@3x.png",
    className: "p10-blocks__fineprint"
  }), [0, 1, 2].map(function (x) {
    return /*#__PURE__*/React.createElement(Block, {
      nr: x,
      page: page,
      thisPage: thisPage,
      key: "p10".concat(x)
    });
  })), [0, 1, 2].map(function (x) {
    return /*#__PURE__*/React.createElement(Block, {
      nr: x,
      mobile: true,
      page: page,
      thisPage: thisPage,
      key: "p10-mobile-".concat(x)
    });
  }));
};
export default P10Blocks;
var Block = function Block(_ref2) {
  var nr = _ref2.nr,
    _ref2$mobile = _ref2.mobile,
    mobile = _ref2$mobile === void 0 ? false : _ref2$mobile,
    page = _ref2.page,
    thisPage = _ref2.thisPage;
  var dispatch = useDispatch();
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    timeArr = _useState4[0],
    setTimeArr = _useState4[1];
  var clearTimers = function clearTimers() {
    timeArr.forEach(function (x) {
      return clearTimeout(x);
    });
    setTimeArr([]);
  };
  useEffect(function () {
    return function () {
      return clearTimers();
    };
  }, []);
  useEffect(function () {
    clearTimers();
    if (page === thisPage) {
      setTimeArr([setTimeout(function () {
        $(".p10-block__".concat(nr)).addClass('p10-block__active');
      }, 2500 + nr * 500)]);
    } else {
      $(".p10-block__".concat(nr)).removeClass('p10-block__active');
    }
  }, [page]);
  var src = {
    0: 'recycled-aggregate-img@3x.png',
    1: 'recycled-sand-img@3x.png',
    2: 'recycled-clay-img@3x.png'
  };
  var txt = {
    0: 'recycled-aggregate@3x.png',
    1: 'recycled-sand@3x.png',
    2: 'recycled-clay@3x.png'
  };
  var url = {
    0: 'https://www.posillicomaterials.com/products/recycled-aggregate',
    1: 'https://www.posillicomaterials.com/products/washed-sand',
    2: 'https://www.posillicomaterials.com/products/recycled-clay'
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "p10-block p10-block__".concat(nr, " ").concat(mobile ? 'p10-block-mobile' : ''),
    onClick: function onClick() {
      dispatch({
        type: appActions.gaEvent,
        payload: {
          category: 'External URL',
          action: 'click',
          label: url[nr]
        }
      });
      window.open(url[nr], '_blank');
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p10/".concat(src[nr]),
    className: "p10-block__img".concat(nr)
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p10/".concat(txt[nr]),
    className: "p10-block__txt".concat(nr)
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p10/chip-underline@3x.png",
    className: "p10-block__border"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p10/chip-bg-full-opacity.png",
    className: "p10-block__bg"
  }), /*#__PURE__*/React.createElement("img", {
    src: "/public/images/our-purpose/p10/yellow-line@3x.png",
    className: "p10-block__line"
  }));
};